var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"id":`iiotDownloadIconUsageReport${_vm.tableItem.name}`,"data-cy":`iiotDownloadIconUsageReport${_vm.tableItem.name}`,"title":_vm.$t('usageReports.list.downloadMessage')},on:{"click":function($event){return _vm.downloadReport(_vm.tableItem.relativePath)}}},[_vm._v(" mdi-file-download-outline ")])
}
var staticRenderFns = []

export { render, staticRenderFns }